import React, { useEffect, useState } from "react";
//#region types
import { InvoiceOverdueBannerProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { DateConstants, IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Banner, GridR, StyledButton, useCheckRelations } from "components/common";
import { Box, CircularProgress, Grid } from "@mui/material";
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { useInvoiceService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const InvoiceDebtCollectionBanner: React.FC<InvoiceOverdueBannerProps> = (props) => {
  const invoiceService = useInvoiceService();
  const { invoice } = props;

  const [data, setData] = useState<WintSuperkollAPIModel.PsCustomerCredentials>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);
    invoiceService
      .getCustomerLink(invoice.id)
      .then((response) => setData(response.data))
      .finally(() => {
        setIsLoading(false);
      });
  }, [invoice.id]);

  const onGoToPsInterfaceClicked = async () => {
    const newUrl = data?.psInterfaceLink;
    window.open(newUrl, "_blank");
  };

  const formatDate = (debtCollectionCreatedDate: string) => {
    return debtCollectionCreatedDate
      ? LocalizationHelperInstance.getFormattedDate(debtCollectionCreatedDate, DateConstants.DateMonthYearShortConfig)
      : "";
  };

  const { getIsReadonlyUser } = useCheckRelations();

  if (getIsReadonlyUser()) {
    return <></>;
  }

  return (
    <Banner
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.DebtCollection)}
      icon={IconDefinitionConstants.WBell}
      type={StyleEnums.DisplayType.Danger}
    >
      {UtilsHelper.isEmpty(data?.caseNumber) === false && isLoading === false ? (
        <GridR container direction="column" spacing={1}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.PsText1, "", {
            date: formatDate(data?.debtCollectionCreatedDate as string),
          })}
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.PsText2, "", {
            caseNumber: data?.caseNumber as string,
          })}
          <Grid item>
            <Box m={0} component="span">
              <StyledButton size="sm" displayType={StyleEnums.DisplayType.Danger} onClick={onGoToPsInterfaceClicked}>
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.PsFinanceInterface)}
              </StyledButton>
            </Box>
          </Grid>
        </GridR>
      ) : (
        <GridR container direction="column" spacing={1}>
          {isLoading === false ? (
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.PsSyncDelay)
          ) : (
            <CircularProgress size={20} className={cssExports.messageBubbleProgress} />
          )}
        </GridR>
      )}
    </Banner>
  );
};

export default InvoiceDebtCollectionBanner;
